var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgColdAirCondition(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66602 3.5H14.3327",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.00065 2.16699C0.82384 2.16699 0.654271 2.23723 0.529247 2.36225C0.404222 2.48728 0.333984 2.65685 0.333984 2.83366V8.16699C0.333984 8.3438 0.404222 8.51337 0.529247 8.6384C0.654271 8.76342 0.82384 8.83366 1.00065 8.83366H2.00065V7.50033H14.0007V8.83366H15.0007C15.1775 8.83366 15.347 8.76342 15.4721 8.6384C15.5971 8.51337 15.6673 8.3438 15.6673 8.16699V2.83366C15.6673 2.65685 15.5971 2.48728 15.4721 2.36225C15.347 2.23723 15.1775 2.16699 15.0007 2.16699H1.00065Z",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 8.83398H13",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66602 6.16699H9.33268",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9.83398V13.834",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.26758 10.834L9.73175 12.834",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.73175 10.834L6.26758 12.834",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.334 13.1673V9.83398",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.666 12.1673V9.83398",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33398 12.1673V9.83398",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66602 13.1673V9.83398",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColdAirCondition);
export default __webpack_public_path__ + "static/media/coldAirCondition.c5bee561.svg";
export { ForwardRef as ReactComponent };